import { useCallback, memo } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedNumber from 'I18n/components/FormattedNumber';
import isNumber from 'transmute/isNumber';
import ColumnIcon from './ColumnIcon';
import ExpandCollapseIconButton from './ExpandCollapseIconButton';
import ColumnHeaderSpacedContent from './ColumnHeaderSpacedContent';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { H6 } from 'foundations-components/transitional/components/H6';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ColumnTitle = /*#__PURE__*/memo(({
  columnData,
  onColumnCollapse,
  onHovered,
  collapsed
}) => {
  const {
    name: columnName,
    id: columnId,
    totalCards
  } = columnData;
  const handleCollapse = useCallback(() => {
    if (onColumnCollapse) {
      onColumnCollapse(columnId, !collapsed, columnData);
    }
  }, [columnId, onColumnCollapse, collapsed, columnData]);
  return /*#__PURE__*/_jsx(Flex, {
    position: "relative",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: collapsed ? 'center' : 'start',
    borderBlockEndWidth: collapsed ? '0' : '100',
    borderBlockEndStyle: "solid",
    borderBlockColor: "border-core-subtle",
    paddingBlock: "400",
    paddingInline: "200",
    backgroundColor: "fill-transparent-default",
    children: collapsed && onColumnCollapse ? /*#__PURE__*/_jsx(ExpandCollapseIconButton, {
      onMouseEnter: () => onHovered(true),
      onMouseLeave: () => onHovered(false),
      expanded: !collapsed,
      onCollapse: handleCollapse
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(H6, {
          margin: "0",
          "data-test-id": "cdb-column-name",
          typography: "heading-25",
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: columnName
          })
        })
      }), /*#__PURE__*/_jsx(H6, {
        margin: "0",
        typography: "heading-25",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          flexWrap: "nowrap",
          alignItems: "center",
          flex: 0,
          children: [isNumber(totalCards) && /*#__PURE__*/_jsx(ColumnHeaderSpacedContent, {
            children: /*#__PURE__*/_jsx(FormattedNumber, {
              value: totalCards,
              "data-test-id": "cdb-column-total-cards"
            })
          }), /*#__PURE__*/_jsx(ColumnIcon, {
            columnData: columnData
          }), onColumnCollapse && /*#__PURE__*/_jsx(ColumnHeaderSpacedContent, {
            children: /*#__PURE__*/_jsx(ExpandCollapseIconButton, {
              onMouseEnter: () => onHovered(true),
              onMouseLeave: () => onHovered(false),
              expanded: !collapsed,
              onCollapse: handleCollapse
            })
          })]
        })
      })]
    })
  });
});
export default ColumnTitle;